import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'vocabulary-audio',
  data: function data() {
    return {
      loading: false,
      query: {
        unit: '',
        status: '',
        keyword: ''
      },
      tableData: [],
      stats: {
        total: 0,
        uploaded: 0,
        pending: 0
      },
      pagination: {
        current: 1,
        size: 20,
        total: 0
      },
      previewVisible: false,
      previewWord: '',
      previewPronunciation: '',
      previewUrl: ''
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                _context.prev = 1;
                params = {
                  unit: _this.query.unit,
                  status: _this.query.status,
                  page: _this.pagination.current - 1,
                  size: _this.pagination.size
                };
                _context.next = 5;
                return _this.$api.getAudioList(params);

              case 5:
                res = _context.sent;
                _this.tableData = res.items || [];
                _this.pagination.total = res.total || 0;

                _this.countStats();

                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);

                _this.$message.error('加载词汇列表失败');

              case 14:
                _context.prev = 14;
                _this.loading = false;
                return _context.finish(14);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11, 14, 17]]);
      }))();
    },
    countStats: function countStats() {
      var _this2 = this;

      this.stats = {
        total: this.pagination.total,
        uploaded: 0,
        pending: 0
      };
      this.tableData.forEach(function (item) {
        if (item.status === 'success') _this2.stats.uploaded++;else _this2.stats.pending++;
      });
    },
    handleUploadOne: function handleUploadOne(row, file) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.$message.info('正在上传 ' + row.word + '...');

                _context2.next = 4;
                return _this3.$api.uploadAudio(row.word, file);

              case 4:
                _this3.$message.success('上传成功: ' + row.word);

                _this3.loadData();

                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                _this3.$message.error('上传失败: ' + row.word);

              case 11:
                return _context2.abrupt("return", false);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }))();
    },
    handlePreview: function handlePreview(row) {
      this.previewWord = row.word;
      this.previewPronunciation = row.pronunciation || '';
      this.previewUrl = row.audioUrl || '';
      this.previewVisible = true;
    },
    handleSearch: function handleSearch() {
      this.pagination.current = 1;
      this.loadData();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pagination.size = size;
      this.loadData();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.pagination.current = page;
      this.loadData();
    },
    statusTagType: function statusTagType(status) {
      var map = {
        success: 'success',
        pending: 'info',
        failed: 'danger'
      };
      return map[status] || 'info';
    },
    statusLabel: function statusLabel(status) {
      var map = {
        success: '已上传',
        pending: '待上传',
        failed: '失败'
      };
      return map[status] || status;
    }
  }
};